/**
 * @desc Treat string amounts kind of language agnostic. Supports '.' or ',' as a delimiter for fractional digits. Use it in combination with `sanitizeMoney`.
 */
export default function parseCents(sanitizedAmount) {
    if (!sanitizedAmount)
        return 0;
    const floatText = sanitizedAmount.replace(/,/g, '.');
    const amountInCurrencyUnits = parseFloat(floatText) || 0;
    return Math.round(amountInCurrencyUnits * 100);
}
//# sourceMappingURL=parseCents.js.map